import React from 'react';
import { StyledDataGrid, customLocaleText } from '../../common/StyledDataGrid';
import { Container, Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function TableList({ listPersonal, loading }) {
  const theme = useTheme(); // Obtén el tema
  const navigate = useNavigate();

  if (!listPersonal || !listPersonal.name_columns || !listPersonal.data) {
    return null;
  }

  const { data, name_columns } = listPersonal;

  const formattedColumns = name_columns
    .filter((col) => col.name !== 'Estación')
    .map((col) => ({
      field: col.key,
      headerName: col.name,
      flex:
        col.name === 'Cedula' ? 0.5 :
        col.name === 'Apellido' ? 1 :
        col.name === 'Nombre' ? 1 :
        col.name === 'Posición' ? 1 :
        col.name === 'Área' ? 1 :
        col.name === 'Turno' ? 1 :
        col.name === 'Estado' ? 0.5 : 1,
      editable: false,
      renderCell: (params) => {
        if (col.key === 'enabled') {
          return params.value === 'ACTIVO' ? (
            <CheckCircleIcon sx={{ color: theme.palette.success.main, backgroundColor: '#E8F5E9', borderRadius: '50%', padding: '2px' }} titleAccess="Empleado activo" />
          ) : (
            <CancelIcon sx={{ color: theme.palette.error.main, backgroundColor: '#ffcdd2', borderRadius: '100%', padding: '2px' }} titleAccess="Empleado inactivo" />
          );
        }
        if (col.key === 'assignment_mode') {
          return params.value === 'occasional' ? 'Ocasional' : 'Regular';
        }
        return params.value;
      },
    }));

  formattedColumns.push({
    field: 'actions',
    headerName: 'Acciones',
    width: 90,
    renderCell: (params) => (
      <IconButton color="primary" onClick={() => handleEditClick(params.row)}>
        <ModeEditIcon />
      </IconButton>
    ),
  });

  const handleEditClick = (row) => {
    navigate(`/personal_edit`, { state: { employeeData: row } });
  };

  return (
    <Container maxWidth="xl" sx={{ padding: 0, mt: 2 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          height: 'calc(100vh - 200px)',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        <Box 
          sx={{ 
            width: '100%',
            overflowX: 'auto',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '0px',
              background: 'transparent',
            },
          }}
        >
          <StyledDataGrid
            rows={data}
            columns={formattedColumns}
            getRowId={(row) => row.ci}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
            localeText={customLocaleText}
            disableSelectionOnClick
            autoHeight
            disableColumnMenu
            hideFooterSelectedRowCount
            disableColumnSelector
            getRowClassName={(params) => 
              params.row.enabled?.toLowerCase() === 'inactivo' ? 'inactive-row' : ''
            }
            loading={loading}
            components={{
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <Typography variant="body1">No se encontraron datos.</Typography>
                  )}
                </Box>
              ),
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}

export default TableList;
